<template>
  <div class="texts-form">
    <h3>Nadpis</h3>
    <div
      class="texts-form__form-element"
      :class="{ 'texts-form__form-element--error': !!validations.title && submited }"
    >
      <input
        id="candidate-consultation-title"
        v-model="editableTitle"
        type="text"
        required
      >

      <p class="texts-form__form-validation">
        {{ validations.title && submited ? validations.title : '' }}
      </p>
    </div>

    <h3>Odstavce</h3>
    <template
      v-for="(paragraph, index) in editableParagraphs"
      :key="`paragraphs-${index}`"
    >
      <div
        class="texts-form__form-element texts-form__form-element--textarea"
        :class="{ 'texts-form__form-element--error': !!validations.paragraphs[index] && submited }"
      >
        <label :for="`paragraph-${index}`"/>
        <textarea
          :id="`paragraph-${index}`"
          v-model="editableParagraphs[index]"
          required
        />

        <p class="texts-form__form-validation">
          {{ validations.paragraphs[index] && submited ? validations.paragraphs[index] : '' }}
        </p>
      </div>

    </template>

    <div class="texts-form__button">
      <button
        class="button"
        @click="() => { editableParagraphs.push(''); validations.paragraphs.push(''); }"
      >
        Přidat odstavec
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import useTexts from '@/store/texts';
import { TextInterface } from '@/types/functions';
import {
  defineComponent,
  reactive,
  ref,
  watch,
  PropType,
} from 'vue';

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<TextInterface>,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const {
      submited,
      isValid,
    } = useTexts();

    // FORM DATA
    const editableTitle = ref(props.modelValue.title || '');
    const editableParagraphs = ref<string[]>(props.modelValue.paragraphs || []);

    // VALIDATION
    const validations = reactive<{
      title: string;
      paragraphs: string[];
    }>({
      title: '',
      paragraphs: [],
    });

    function validateTitle() {
      if (!editableTitle.value) {
        validations.title = 'Nadpis musí být vyplněn';
      } else {
        validations.title = '';
      }
    }

    function validateParagraphs() {
      editableParagraphs.value.forEach((paragraph, index) => {
        if (!paragraph) {
          validations.paragraphs[index] = 'Odstavec nesmí být prázdný';
        } else {
          validations.paragraphs[index] = '';
        }
      });
    }

    function validate() {
      validateTitle();
      validateParagraphs();

      isValid.value = !validations.title && validations.paragraphs.find((paragraph) => paragraph) === undefined;
    }

    validate();

    watch([editableTitle, editableParagraphs], () => {
      validate();
      emit('update:modelValue', {
        title: editableTitle.value,
        paragraphs: editableParagraphs.value,
      });
    }, { deep: true });

    return {
      editableTitle,
      editableParagraphs,
      validations,
      submited,
    };
  },
});
</script>

<style lang="scss" scoped>
.texts-form {
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 0 0 calc(60% - 20px);

  @media screen and (max-width: 600px){
    flex: auto;
    height: auto;
  }

  @media screen and (max-width: 600px) {
    width: 100%;
  }

  & > * {
    margin-bottom: 10px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__form-validation {
    margin: 0 !important;
    padding: 2px 0 !important;
    font-size: 0.8rem;
    font-weight: 400;
    color: red;
    text-align: left !important;
  }

  &__form-message {
    padding: 10px 20px;
    border-radius: 3px;

    &--error {
      background-color: red;
      color: white;
    }

    &--success {
      background-color: green;
      color: white;
    }

    & p {
      font-weight: 300;
      font-size: 0.7rem;
      margin: 10px 0 0;
    }
  }

  &__form-element {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 5px;

    textarea, input {
      border: 1px solid $color-blue;
      border-radius: 5px;
      padding: 5px 10px;
    }

    &--error {
      & textarea, input {
        border: 1px solid red;
      }
    }

    &--textarea {
      height: 100px;

      @media screen and (max-width: 600px) {
        height: 100px;
      }

      & textarea {
        height: 100%;
        resize: none;

        @media screen and (max-width: 600px) {
          height: 100px;
        }
      }
    }
  }
}
</style>
